import axios from 'axios';
import qs from 'qs';
import router from '../router'
import {HttpConfig} from '../config/config'
axios.defaults.timeout = HttpConfig.TiMEOUT;
// axios.defaults.withCredentials = HttpConfig.COOKIE;
axios.defaults.withCredentials = false;
//http request 拦截器
axios.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json'
        config.headers['Cache-Control'] = 'no-cache'
        config.headers['Pragma'] = 'no-cache'
        let token = localStorage.getItem("token");
        if (token != null && config.url !== "/user/login/") {
            config.headers.Authorization = "Bearer" + " " + token
        }
        if (config.url ==='/sbom/upload_sbom/'||config.url ==='/sbom/edit_sbom/') {
            //config.timeout = 3600000;
            config.headers['Content-Type'] = 'multipart/form-data'
        };
        // console.log('请求：', config);
        return config;
    },
    error => {
        console.log('请求出错', error);
        return Promise.reject(err);
    }
);

let flag = true; //当多个请求同时出现错误时保持只执行一个弹框 true为可以弹窗
//http response 拦截器
axios.interceptors.response.use(
    response => {
        // console.log('响应：' + response.config.url.substring(response.config.url.lastIndexOf("/") + 1), response);
        return response;
    },
    error => {
        console.log(error.response);
        // 响应报错处理和超时处理
        if (error.response) {
           // if (error.response.status == HttpConfig.USER_CODE && error.response.data.data == HttpConfig.USER_UNAUTHORIZED) {
            if (error.response.status == 401) {
                if (localStorage.getItem("token") !== null) {
                    // this.$store.dispatch('logout')
                    // router.push({
                    //     name: "login"
                    // });
                }
            }else{
                // router.push({
                //     name: "login"
                // });
            }
        } else if (error.request) {
              /* this.$message({
                message: '网络连接失败，请刷新或重试',
                center: true,
                type: "error",
                message: '网络连接失败，请刷新或重试',
                duration: 1000,
                showClose: true
              }); */
        } else {
           /*  this.$message({
                type: "error",
                message: '未知的的错误，请刷新或重试',
                duration: 1000,
                showClose: true
              }); */
        }
        console.log(error.config);
        return Promise.reject(error)
    }
)

/*
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        qs.stringify(params)
        axios.get(url, {
                params: params
            })
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, params, config) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, config)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(url, params = {}) {
    return new Promise((resolve, reject) => {
        qs.stringify(params)
        axios.delete(url, {
                params: params
            })
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * 封装二进制文件流下载文件专用请求,GET请求下载
 * @param url
 * @param data
 * @returns {Promise}
 */
export function download(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params,
                responseType: 'blob'
            })
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * 封装二进制文件流下载文件专用请求,POST请求下载
 * @param url
 * @param data
 * @returns {Promise}
 */
export function downloadPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
                responseType: 'blob'
            })
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err)
            })
    })
}